var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19594_51258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 28L20.3 28.86C20.1 28.28 20 27.65 20 27C20 26.76 20 26.5 20.04 26.29L19 25.6L16 27.6L13 25.6L12 26.26V13H26V21C26.7 21 27.37 21.12 28 21.34V11H10V30L13 28L16 30L19 28ZM24 17V15H14V17H24ZM22 21V19H14V21H22ZM22.5 27L25.25 30L30 25.23L28.84 23.82L25.25 27.41L23.66 25.82L22.5 27Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19594_51258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.fef21ba85753d6b0779a2f1721067ce3.svg";
export { ForwardRef as ReactComponent };